import { Icons, NewContainerIcons } from '@/assets';
import { Icon } from '@/components/Icon';
import LoadingV2 from '@/components/Loading';
import { TableV3 } from '@/components/TableV3';
import CountUpDown from '@/components/CountUpDown';
import IconButton from '@/ctComponents/IconButton';
import timeAgo from '@/ctUtlis/timeAgo';
import React, { useMemo } from 'react';

export const SearchResultListView = ({
  loading,
  DATA,
  openReserve,
  setReserveInformation,
  reservedItem,
  activeNotify,
  noCountChange = false,
}) => {
  const columns = useMemo(() => {
    return [
      {
        field: 'cabin.company',
        label: 'SSL',
        align: 'center',
        sortValue: (row) => row.cabin.company.name,
        component: (row) => {
          return (
            <div className="py-1 flex items-center  gap-2">
              <img
                src={
                  NewContainerIcons[
                    row.cabin.company.name.replace(/\s+/, '')
                  ] || NewContainerIcons.defaultOrangeContainer
                }
                alt={row.cabin.company.name}
                className="h-11 object-contain max-w-64"
                style={{
                  paddingRight: '10%',
                }}
              />

              {row.cabin.company.name}
            </div>
          );
        },
      },
      {
        field: 'cabin.specifications.size_type',
        label: 'Size',
        align: 'center',
        sort: true,
        component: (row) => row.cabin.specifications.size_type,
        sortValue: (row) => row.cabin.specifications.size_type,
      },
      {
        field: 'loc',
        label: 'Location',
        align: 'center',
        sort: true,
        component: (row) => row.address.city,
        sortValue: (row) => row.address.city,
      },
      {
        field: 'count',
        label: 'Total Number',
        align: 'center',
        sort: true,
        component: (row) => {
          const currentValue = Number(
            row.id === reservedItem?.id
              ? reservedItem?.count
              : row.count_available
          );
          const maxValue = row.count_available;
          const minValue = 1;

          const handleCountChange = (newValue) => {
            setReserveInformation((pre) => ({
              ...pre,
              item: {
                ...row,
                count: newValue,
              },
            }));
          };

          const increment = () => {
            if (currentValue < maxValue) {
              handleCountChange(currentValue + 1);
            }
          };

          const decrement = () => {
            if (currentValue > minValue) {
              handleCountChange(currentValue - 1);
            }
          };

          return (
            <CountUpDown
              currentValue={currentValue}
              maxValue={maxValue}
              minValue={minValue}
              onIncrement={increment}
              onDecrement={decrement}
              disabled={noCountChange}
              valueClassName="px-3 text-center"
            />
          );
        },
        sortValue: (row) => row.count_available,
      },

      {
        field: 'own_chases_count',
        label: 'Num of Own Chassis',
        align: 'center',
        sort: true,
        component: (row) => row.own_chases_count,
        sortValue: (row) => row.own_chases_count,
      },
      {
        field: 'pool_chases_count',
        label: 'Num of Pool Chassis',
        align: 'center',
        sort: true,
        component: (row) => row.pool_chases_count,
        sortValue: (row) => row.pool_chases_count,
      },
      {
        field: 'flip_available',
        label: 'Flip Available',
        align: 'center',
        sort: true,
        component: (row) => (row.flip_available ? 'Yes' : 'No'),
        sortValue: (row) => row.flip_available,
      },
      {
        field: 'updated_at',
        label: 'Last Update',
        align: 'center',
        sort: true,
        component: (row) => <span>{timeAgo(row.updated_at)}</span>,
        sortValue: (row) => row.updated_at,
      },
      {
        field: '',
        label: 'Action',
        align: 'center',
        component: (row) => (
          <button
            className="m-auto shadow-none cursor-pointer border-none flex items-center gap-1 hover:underline font-bold text-xs bg-transparent hover:opacity-100 text-primary-blue hover:text-primary-blue-hover"
            onClick={() => openReserve(row)}>
            Reserve
            <Icon src={Icons.rightBlueArrow} width={16} height={16} />
          </button>
        ),
      },
    ];
  }, [openReserve, reservedItem, setReserveInformation]);

  return (
    <div className="w-full pr-2 col-span-1 lg:col-span-3 2xl:col-span-2">
      {!loading && DATA.length === 0 ? (
        <div className="flex flex-col items-center justify-center mt-16">
          <Icon src={Icons.infoEmptyList} width={24} height={24} />
          <p className="text-inactive-text font-bold text-lg m-0 mt-4 mb-1">
             No Results Found
          </p>
          <p className=" text-inactive-text text-base m-0 mb-6">
            Currently, there are no active offers for this search. Add it to
            your save list, and we’ll notify you via email as soon as an offer
            becomes available
          </p>
          <IconButton
            icon="list"
            text="Add to Save List "
            onClick={activeNotify}
            color="#525866"
            style={{
              height: 40,
              width: 110,
              marginRight: 8,
            }}
          />
        </div>
      ) : (
        !(loading && DATA.length === 0) && (
          <div className="mb-4">
            <TableV3
              headers={columns}
              data={DATA || []}
              emptyMessage=""
              minWidth="870px"
              stickyHeader={true}
              appHeaderHeight={64}
            />
          </div>
        )
      )}

      {loading && (DATA.length === 0 || (DATA && DATA.length > 0)) && (
        <div className="flex justify-center py-4">
          <LoadingV2 />
        </div>
      )}
    </div>
  );
};

export default SearchResultListView;
